import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 償却資産区分 */
enum DepreciationAsset {
  tangibleFixedAsset = 'TANGIBLE_FIXED_ASSET',
  intangibleFixedAsset = 'INTANGIBLE_FIXED_ASSET',
  creature = 'CREATURE',
  deferredAsset = 'DEFERRED_ASSET',
}

const nameConfig = {
  tangibleFixedAsset: new Map([
    [Locale.ja, '有形固定資産'],
    [Locale.en, 'Tangible Fixed Asset'],
  ]),
  intangibleFixedAsset: new Map([
    [Locale.ja, '無形固定資産'],
    [Locale.en, 'Intangible Fixed Asset'],
  ]),
  creature: new Map([
    [Locale.ja, '生物'],
    [Locale.en, 'Creature'],
  ]),
  deferredAsset: new Map([
    [Locale.ja, '繰延資産'],
    [Locale.en, 'Deferred Asset'],
  ]),
};

const toEnum = rawValueToEnum(DepreciationAsset, '');
const toDisplay = enumToName(DepreciationAsset, nameConfig);
const toDisplayWithPrefix = enumToName(DepreciationAsset, nameConfig, { prefix: true });

export const depreciationAsset = {
  enum: DepreciationAsset,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { DepreciationAsset };
